import React from 'react';
import {BrowserRouter, Routes, Route} from 'react-router-dom';
import Pages from './Pages';
import withRedirectionStrategy from './HOC/withRedirectionStrategy';
import {ROUTES, IS_IE_BROWSER} from './constants';

const EAP = withRedirectionStrategy(Pages.EAP);
const Membership = withRedirectionStrategy(Pages.Membership);
const Activated = withRedirectionStrategy(Pages.Activated);
const PasswordGeneration = withRedirectionStrategy(Pages.PasswordGeneration);

const Router = () => {
    return (
        <BrowserRouter>
            <Routes>
                {IS_IE_BROWSER && <Route path='*' element={<Pages.IESunset/>}/>}

                {!IS_IE_BROWSER && (
                    <React.Fragment>
                        <Route path={ROUTES.eap} element={<EAP/>}/>

                        <Route path={ROUTES.membership} element={<Membership/>}/>

                        <Route path={ROUTES.activated} element={<Activated/>}/>

                        <Route path={ROUTES.sftpPasswordGeneration} element={<PasswordGeneration/>}/>

                        <Route path={`${ROUTES.serverError}/:errorCode`} element={<Pages.ServerError/>}/>
                        <Route path={ROUTES.pageNotFound} element={<Pages.PageNotFound/>}/>
                        <Route path={ROUTES.manyRequests} element={<Pages.ManyRequests/>}/>

                        <Route path='*' element={<Pages.PageNotFound/>}/>
                    </React.Fragment>
                )}
            </Routes>
        </BrowserRouter>
    );
};

export default Router;
